module.exports = __webpack_public_path__ + "public/img/ico-tabbar-active-clients.e2c5ddfc.svg";